import React, { useEffect } from "react";
import BackLink from "../components/BackLink";
import TopHeader from "../components/TopHeader";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchArticleById,
  SelectedArticle,
  selectSuggestions,
} from "../store/slices/blogSlice";
import { useNavigate, useParams } from "react-router-dom";
import { formattedDate } from "../utils/utils";
import Article from "../components/Article";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import SingleArticleSkeleton from "../components/skeletons/SingleArticleSkeleton";
import { Helmet, HelmetProvider } from "react-helmet-async";

function SignleArticle() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selected = useSelector(SelectedArticle);
  const suggestions = useSelector(selectSuggestions);
  const status = useSelector((state) => state.blog.status);

  useEffect(() => {
    if (id) {
      dispatch(fetchArticleById(id));
    }
  }, [id, dispatch]);

  return (
    <>
   
      <TopHeader btn={true} />

      {status == "loading" ? (
        <>
          <SingleArticleSkeleton />
        </>
      ) : (
        <>
          <div className="container mt-40">
            <BackLink />
            <h2>{selected?.titre}</h2>

            <div className="d-flex mt-16">
              <img
                src="/images/calendar-start.svg"
                className="mr-8"
                alt="calendar"
              />
              <span className="tag-date legend grey66">
                {formattedDate(selected?.published_at)}
              </span>
            </div>

            <div
              className="white-title mt-40 imgContainer"
              dangerouslySetInnerHTML={{ __html: selected?.contenu }}
            ></div>
          </div>
        </>
      )}
      <div className="backgroud-actualite">
        <div className="container space-blog px-80">
          <h2>Autres actualités</h2>
          <div className="row mt-32">
            {status == "loading"
              ? Array(3)
                  .fill(0)
                  .map((_, idx) => (
                    <div className="col" key={idx}>
                      <Skeleton height={200} />
                    </div>
                  ))
              : suggestions?.map((element, index) => (
                  <Article
                    className="pointer"
                    element={element}
                    key={element?.id || index}
                    onClick={() => navigate(`/articles/${element?.id}`)}
                  />
                ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default SignleArticle;
